import React from "react";

const NotFound: React.FC = () => {
  return <>Page not found</>;
};

export default NotFound;
